import { createSolarApi } from './core/api/solarApi.js';
import { createAshpApi } from './core/api/ashpApi.js';
import { createFinanceApi } from './core/api/financeApi.js';
import { formatCurrencyGBP, formatNumber, formatPercent } from './core/utils/format.js';
import { debounce } from './core/utils/debounce.js';
import { getQueryParam, getQueryParams } from './core/utils/params.js';
import { getStoredItem, setStoredItem, removeStoredItem } from './core/utils/storage.js';

const dwellow = typeof window !== 'undefined'
    ? (window.Dwellow = window.Dwellow || {})
    : {};

dwellow.core = {
    api: { createSolarApi, createAshpApi, createFinanceApi },
    utils: {
        formatCurrencyGBP,
        formatNumber,
        formatPercent,
        debounce,
        getQueryParam,
        getQueryParams,
        getStoredItem,
        setStoredItem,
        removeStoredItem
    }
};

export {
    createSolarApi,
    createAshpApi,
    createFinanceApi,
    formatCurrencyGBP,
    formatNumber,
    formatPercent,
    debounce,
    getQueryParam,
    getQueryParams,
    getStoredItem,
    setStoredItem,
    removeStoredItem
};
